// src/hooks/useHouses.js
// Gère la collection houses/{houseId} avec membres
import { useState, useEffect, useCallback } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import {
  subscribeHousesForUser,
  createHouse,
  updateHouse,
  deleteHouseDoc,
  db,
} from '../lib/firebase';

export function useHouses(uid) {
  const [houses,  setHouses]  = useState([]);
  const [loading, setLoading] = useState(true);

 useEffect(() => {
  if (!uid) {
    setHouses([]);
    setLoading(false);
    return;
  }

  setLoading(true);

  const unsub = subscribeHousesForUser(uid, (list) => {
    setHouses(list || []);
    setLoading(false);
  });

  return () => unsub?.();
}, [uid]);

  const addHouse = useCallback(async (name) => {
    if (!uid || !name.trim()) return null;
    const id = await createHouse(uid, name.trim());
    return id;
  }, [uid]);

  const renameHouse = useCallback(async (houseId, name) => {
    await updateHouse(houseId, { name: name.trim() });
  }, []);

  const removeHouse = useCallback(async (houseId) => {
    await deleteHouseDoc(houseId);
  }, []);

  const updateHouseDoc = async (id, data) => {
    const ref = doc(db, 'houses', id);
    await updateDoc(ref, data);
  };

  return { houses, loading, addHouse, renameHouse, removeHouse, updateHouseDoc };
}
